"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _get = _interopRequireDefault(require("lodash/get"));
var _RecentActivityTableComponent = _interopRequireDefault(require("../../RecentActivity/RecentActivityTable/RecentActivityTableComponent"));
var _config = _interopRequireDefault(require("../../../config"));
var _recentActivityHelper = require("../../../helpers/recentActivityHelper");
var _recentActivitySelector = require("../../../redux/selectors/recentActivitySelector");
var _orderHistoryActions = require("../../../redux/actions/orderHistoryActions");
var _reactI18next = require("react-i18next");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var minRow = ownProps.minRow,
    pageSize = ownProps.pageSize;
  var usePagination = _config["default"].OrderHistoryData.usePagination;
  var data = (0, _recentActivitySelector.newRecentActivitySelector)(state);
  return {
    data: data,
    minRow: minRow,
    pageSize: pageSize,
    usePagination: usePagination,
    columns: (0, _recentActivityHelper.getColumns)(ownProps.width, ownProps.themeModifier, ownProps.t),
    selectedAccountId: (0, _get["default"])(state, 'user.selectedAccountId', 0),
    OMSId: (0, _get["default"])(state, 'user.userInfo.OMSId', 1),
    recentActivityStartIndex: state.apexCore.orderHistory.recentActivityStartIndex,
    selectedProductId: state.apexCore.position.selectedProductId,
    TransactionReferenceTypes: (0, _get["default"])(state, ['form', 'recent-activity', 'values', 'type'], 'all'),
    StartDate: (0, _get["default"])(state, ['form', 'recent-activity', 'values', 'startDate'], undefined),
    EndDate: (0, _get["default"])(state, ['form', 'recent-activity', 'values', 'endDate'], undefined)
  };
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)('activity')((0, _reactRedux.connect)(mapStateToProps, {
  getRecentActivity: _orderHistoryActions.getRecentActivity
})(_RecentActivityTableComponent["default"]));